module.exports = __webpack_public_path__ + "static/img/7f85ff6bc19e3e113cdac787335179ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/codeImg.png
// module id = MEGb
// module chunks = 1